import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ingredientByLocationApi,
  ingredientDetailsApi,
  ingredientDetailBySlugApi,
  locationApi,
} from "./ingredient.wpapi";
import {
  getFormattedIngredient,
  getPreviewImages,
} from "../../utils/ingredientUtils";
const USE_INGREDIENT_SLUG =
  process.env.REACT_APP_USE_INGREDIENT_SLUG === "TRUE";

export const fetchIngredientLocations = createAsyncThunk(
  "ingredient-location/get",
  async () => {
    const response = await locationApi();
    return response;
  },
);

export const fetchIngredientPreview = createAsyncThunk(
  "ingredient-preview/get",
  async (location, { getState }) => {
    const response = await ingredientByLocationApi(location);
    if (!response?.length || response.data?.status === 404) return [];
    if (!USE_INGREDIENT_SLUG) {
      const { language } = getState().reducer;
      const previews = getPreviewImages(response);
      return response.map((post, index) =>
        getFormattedIngredient(post, previews[index], language),
      );
    }
    return response;
  },
);

export const fetchIngredientDetails = createAsyncThunk(
  "ingredient-detail/get",
  async (slugOrId, { rejectWithValue }) => {
    if (USE_INGREDIENT_SLUG) {
      const response = await ingredientDetailBySlugApi(slugOrId);
      if (!response) return rejectWithValue("Post not found");
      return response;
    }
    if (slugOrId) {
      const response = await ingredientDetailsApi(slugOrId);
      return response;
    }
    return false;
  },
);
